import * as React from 'react';
import {connect} from 'react-redux';

import {RootState} from '../../store/State';

interface Props {
    docked: boolean;
    children?: React.ReactNode;
}

/**
 * This is a workaround for changes to the `-webkit-app-region` CSS property not being respected by the renderer unless
 * the affected HTML is fully rerendered. We'll typically change this property when the launcher changes between docked
 * and undocked, so this sets a key dependent on that setting, to force a rerender when it changes.
 */
const DockedDependentComponent: React.FC<Props> = (props: Props) => {
    const {docked, children} = props;

    return <React.Fragment key={docked ? 'docked' : 'undocked'}>{children}</React.Fragment>;
};

const mapState = (state: RootState, ownProps: Partial<Props>) => ({
    docked: ownProps.docked !== undefined || state.settings.launcherDocked
});

export const DockedDependent = connect(mapState)(DockedDependentComponent);
